import React from 'react'
import './Coupon_Card.css'

import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Green_Btn from '../../common_btn/green_btn/Green_Btn'
import { Link } from 'react-router-dom'

const Coupon_Card = ({ val, applied, data, price, showtc, handelSubmit }) => {
    return (
        <section className='Coupon_Card'>
            <div className='top_div'>
                <div className='left_side'>
                    <img src='/assets/images/checkout/discount.png' className='discount_img' />
                    <p className='coupon_code'>{`${val?.code || " "} | ${val?.name || " "} `}</p>
                </div>
                <div className='apply_div'>
                    <Green_Btn btn_name={applied?.id === val?.id ? "Applied" : "Apply"} onClick={() => handelSubmit(val)} />
                </div>
            </div>

            <div className='content_text_div'>
                <p className='main_text'> Save ₹
                    {val?.Discount_Type?.id === 2
                        ? (
                            ((price || data?.total_selling_price || 0) *
                                (val?.discount || 0)) /
                            100
                        ).toFixed(2)
                        : parseFloat(val?.total_amount || 0).toFixed(2)}{" "}
                    on this order!</p>

                <ul>
                    <li className='point_text'> Flat{" "}
                        {val?.Discount_Type?.id === 2
                            ? `${val?.discount}%`
                            : ` ₹ ${val?.total_amount}`}{" "}</li>
                    <li className='point_text'>{val?.info}</li>
                    <li className='point_text'>{val?.message}</li>
                    <li className='point_text'>Valid on minimum purchase of ₹{val?.required_amount}{" "}</li>

                </ul>

                {showtc && (
                    <Link to={"/settings/terms-conditions"}>

                    <div className='tc_div'>
                        <p className='tc_text'>Terms & Conditions <FontAwesomeIcon icon={faAngleRight} className="arrow_icon" /></p>
                    </div>
                    </Link>
                )}
            </div>

        </section>
    )
}

export default Coupon_Card
